<template>
  <div class="container-fluid">
    <h5 class="mt-2">Edytuj Wydatek</h5>
    <div class="row mt-3">
      <div class="col-6 col-sm-6 col-md-6">
      <form @submit.prevent="submit" >
        <div class="form-group" v-if="errors.length" >
          <ul class="list-group">
            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="form-group input-group-sm">
          <label >Wydatek</label>
          <input class="form-control" v-model="form.expenseName"/>
        </div>
        <div class="form-group input-group-sm">
          <label >Kwota</label>
          <input class="form-control" type="number" min="0" step="any" v-model="form.expensePrice"/>
        </div>
        <div class="form-group input-group-sm">
          <label >Data</label>
          <datepicker 
                class="mt-1 "
                v-model="form.expenseDate"
                :monday-first="true"
                :language="lang"
            ></datepicker>
        </div>
        <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz">
        <router-link class="btn btn-secondary btn-sm" :to="{ name: 'expenses' }">Anuluj</router-link>
      </form>
      </div>
    </div>
  </div>
</template>
<script>
import {pl} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import alertify from 'alertifyjs'
import ExpensesService from "@/components/expenses/ExpensesService"
const expensesService = new ExpensesService()

export default {
    components: {
      datepicker 
    },
    name: 'ExpensesNew',
    data: function () {
        return {
            errors: [],
            lang: pl,
            form: {
                expenseId: this.$route.params.id,
                expenseName: "",
                expenseDesc: "not used",
                expensePrice: "",
                expenseDate: moment().format("YYYY-MM-DD")
            }
        }
    },
    created() {
        this.initData()
    },
    methods: {
        initData() {
            expensesService.loadExpense(this.form.expenseId, this.onLoadSuccess, this.onLoadError)
        },
        onLoadSuccess(expense) {
            this.form = expense
        },
        onLoadError(err) {
            console.log(err)
            this.$router.push({name: 'expenses'})
            alertify.error("Nie można pobrać wydatku.").delay(3);
        },
        submit() {
            this.clearErrors()
            expensesService.update(this.form, this.onUpdateSuccess, this.onUpdateError)
        },
        onUpdateSuccess(data) {
            this.$router.push({name: 'expenses'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Wydatek został zapisany").delay(3);
        },
        onUpdateError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można edytować wydatku.").delay(3);
        },
        clearErrors() {
            this.errors = []
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/expenses/ExpensesEdit.vue